<template>
  <Section
    v-bind="$attrs"
    title="Manufacturers"
    :shouldShowSearch="shouldShowSearch"
    :toolbarActions="toolbarActions"
    @onClicked="(val) => $emit(val)"
    icon="store"
    :isLoading="isLoading"
    @onShouldSearch="(val) => (searchText = val)"
  >
    <v-data-table
      :headers="headers"
      :items="manufacturerList"
      item-key="id"
      :search="searchText"
      class="elevation-1"
      :rows-per-page-items="[15, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.modelCount }}</td>
        <td class="text-xs-left">{{ props.item.assetCount }}</td>
        <td class="text-xs-left">
          <v-icon :color="props.item.isEnabled ? 'green' : 'red'">{{
            props.item.isEnabled ? "done" : "close"
          }}</v-icon>
        </td>
        <td class="text-xs-right">
          <ControlButton
            text="Edit"
            icon="edit"
            iconColor="warning"
            :disabled="isLoading"
            @onClicked="
              $emit('onEditManufacturerClicked', {
                manufacturerToEdit: props.item,
              })
            "
          />
        </td>
      </template>
    </v-data-table>
  </Section>
</template>

<script>
import Section from '../../../../common/components/layouts/Section'
import ControlButton from '../../../../common/components/controls/ControlButton'

export default {
  inheritAttrs: false,
  components: {
    Section,
    ControlButton,
  },
  props: {
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
    shouldShowSearch: {
      type: Boolean,
    },
    manufacturerList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    searchText: null,
    headers: [
      { text: 'Name', value: 'name', align: 'left', sortable: false },
      {
        text: 'Model Count',
        value: 'modelCount',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Equipment Count',
        value: 'assetCount',
        align: 'left',
        sortable: false,
      },
      { text: 'Enabled', value: 'isEnabled', align: 'left', sortable: false },
      { text: '', sortable: false },
    ],
  }),
  computed: {},
  methods: {},
}
</script>
